import {Component, ComponentRef, Injector, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { ObjectsService } from "../../../../services/objects.service";
import { KeySyncModel, KeySyncViewModel } from "../../Keys/Model/KeyViewModel";
import { GroupFilterModel } from "../../../shared/pipes/FilterByNameAndGroup.pipe";
import {DialogService} from "../../../../services/dialog.service";
import {KeysService} from "../../../../services/keys.service";
import {ObjectsManagementDialogComponent} from "../../objects-management-dialog/objects-management-dialog.component";
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { EditObjectsComponent } from "../../Objects/edit-objects.component";
import {ObjectCreateViewModel} from "../../Objects/Models/ObjectViewModel";

@Component({
    selector: 'app-keyobjects-sync-dialog',
    templateUrl: './keyobjects-sync-dialog.component.html',
    styleUrls: ['./keyobjects-sync-dialog.component.css'],
    standalone: false
})
export class KeyObjectsSyncDialogComponent extends DialogBaseComponent<KeySyncViewModel> implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;
  @ViewChild("mgmtDialog", { read: ViewContainerRef, static: true }) container;
  protected componentRef: ComponentRef<any>;

  private objectsService: ObjectsService;
  private dialogService: DialogService;
  private keysService: KeysService;

  public keys: KeySyncViewModel[] = [];
  // public keyObjects: ObjectViewModel[] = [];
  public filter: GroupFilterModel = new GroupFilterModel();
  public nameFilter: string;
  public forceRemove: KeySyncViewModel[] = [];

  public keyId: number;

  @Input('keyId')
  set onKeyIdSet(id) {
    this.keyId = id;
    this.Refresh();
  }

  private Refresh() {
    this.keysService.GetSyncKeysForKey(this.keyId)
      .subscribe(keys => {
        this.keys = keys;
      })
  }


  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "syncKeys";
    this.objectsService = injector.get(ObjectsService);
    this.keysService = injector.get(KeysService);
    this.dialogService = injector.get(DialogService);
  }

  public selectKeys() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsService.GetObjects()
      .subscribe(objects => {
        this.objectsListDialog.instance.objects = objects.filter(k => this.keys.map(ks => ks.ObjectId).indexOf(k.Id) < 0);
      });
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      //keys not in the sync table
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(object => {
        if (object && object.IsChecked) {
          let model = new KeySyncViewModel();
          model.ObjectId = object.Id;
          model.KeyId = this.keyId;
          model.Id = model.ObjectId;
          model.ObjectName = object.Name;
          model.Name = object.Name;
          model.NeedAdd = true;
          this.keys.push(model);
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }

  public onTermChange(event: Event) {
    const term = (event.target as HTMLInputElement).value;
    this.filter.term = term;
  }

  ngOnInit() {
    this.Refresh();
  }

  resyncKeys() {
    let model = this.keys.filter(k => k.IsChecked == true && k.NeedDelete == false);

    this.keysService.ResyncKeys(model)
      .subscribe(() => {
        this.Refresh();
      });
  }

  openEditKeyDialog(key: KeySyncViewModel) {
    this.componentRef = this.dialogService.open(this.container, EditObjectsComponent);
    this.componentRef.instance.model = new ObjectCreateViewModel();
    this.componentRef.instance.onSubmit.subscribe(() => {
      let updatedObject = this.componentRef.instance.model;
      let keySyncModel = this.keys.find(k => k.Id == updatedObject.Id);
      if (keySyncModel) {
        keySyncModel.Name = updatedObject.Name;
        keySyncModel.ObjectName = updatedObject.Name;
      }

    });
    this.objectsService.GetObject(key.ObjectId)
      .subscribe(object => {
        this.componentRef.instance.open(object);
        //this.componentRef.instance.model = object;
      });
  }


  public onToggleAll(value: boolean) {
    this.keys.forEach((command) => {
      command.IsChecked = value;
    });
    this.selectObjectsCount = this.keys.filter(c => c.IsChecked).length;
  }


  public onToggle(val: any) {
    this.selectObjectsCount = this.keys.filter(c => c.IsChecked).length;
  }

  deleteKeyFromSync(key: KeySyncViewModel) {
    if (key.NeedDelete == true) {
      let message = this.translate.instant("Delete");
      if (!confirm(message + " " + key.Name + "?")) return;
      this.forceRemove.push(key);
      let idx = this.keys.indexOf(key);
      this.keys.splice(idx, 1);
    } else {
      key.NeedDelete = true;
    }
  }


  deleteSelected() {
    for (let key of this.keys.filter(k => k.IsChecked)) {
      key.NeedDelete = true;
      key.IsChecked = false;
    }
  }

  public submit()
  {
    this.keysService.SetSyncKeysForKey(this.keyId, this.keys.filter(k => !k.NeedDelete).map(k => k.ObjectId))
      .subscribe(() => { });

    super.submit();
  }
}
